import type { RouteObject } from "react-router-dom";
import NotFound from '@/pages/NotFound';
import Home from '@/pages/home/page';
import ArticlePage from '@/pages/article/page';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artikel/:slug",
    element: <ArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;